import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import reactParser, { Comment, Element, ProcessingInstruction, Text, attributesToProps, domToReact, } from 'html-react-parser';
import Typography from '../../components/common/typography';
export { Element, attributesToProps, domToReact };
const isDomToReactNode = (node) => node instanceof Comment ||
    node instanceof Element ||
    node instanceof ProcessingInstruction ||
    node instanceof Text;
export const domToReactChildren = (children, options) => domToReact(children.filter(isDomToReactNode), options);
export const parseOptions = {
    replace: (domNode) => {
        if (domNode.attribs && domNode.name === 'a') {
            const props = attributesToProps(domNode.attribs);
            return (_jsx("a", Object.assign({}, props, { rel: "nofollow", target: "_blank", children: domToReactChildren(domNode.children) })));
        }
        if (domNode.attribs && domNode.name === 'p') {
            return _jsx(Typography, { children: domToReactChildren(domNode.children) });
        }
        if (domNode.attribs && domNode.name === 'img') {
            return _jsx(_Fragment, {});
        }
    },
};
const parse = (content, options = parseOptions) => {
    return reactParser(content, options);
};
export default parse;
